import Vue from '../../vue';
import store from '../../store';
import router from '../../router';

Vue.directive('right-click-menu', {
  inserted: (el, binding) => {
    const link = (router.match(binding.value).matched[0] || {}).path || binding.value;

    const onClickCallback = event => {
      store.state.rightClickEvent = { event, link };
      event.preventDefault();
    };
    el.addEventListener('contextmenu', onClickCallback)
  },
});
